import request from '@/utils/request'
import { uuid } from 'vue-uuid';
import { obj2query } from '@/utils'
import { getToken } from '@/utils/auth'

export function getCustomerByProject(project_uid, query){
  return request({
    url: `/api/customers/project/${project_uid}${obj2query(query)}`,
    method: "get"
  });
}

export function getCustomerDropdown(project_uid){
  return request({
    url: `/api/customers/project/${project_uid}/dropdowns`,
    method: "get"
  });
}

export function getCustomerBy(uid){
  return request({
    url: "/api/customers/" + uid,
    method: "get"
  });
}
export function getUtility(){
  return request({
    url: "/api/customers/utility",
    method: "get"
  });
}

export function getMemberInfo(query){
  return request({
    url: `/api/customers/memberinfo${obj2query(query)}`,
    method: "get"
  });
}

export function createCustomer(project_uid, data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/customers/project/" + project_uid,
    method: "post",
    data: data
  });
}

export function updateCustomer(uid, data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/customers/" + uid,
    method: "put",
    data: data
  });
}

export function deleteCustomer(uid){
  return request({
    url: "/api/customers/" + uid,
    method: "delete",
    data: {idempotency: uuid.v1()}
  });
}

export function getCustomerExcel(project_uid, filename){
  let query = {
    access_token : getToken()
  }
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  link.href = `${baseURL}/api/customers/project/${project_uid}/excel${obj2query(query)}`;
  if(filename){
    link.download = filename
  }
  link.click()
}

export function getRestrictList(){
  return request({
    url: "/api/customers/restrict",
    method: "get"
  });
}

export function getRestrict(uid){
  return request({
    url: "/api/customers/restrict/" + uid,
    method: "get"
  });
}

export function createRestrict(data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/customers/restrict",
    method: "post",
    data: data
  });
}

export function updateRestrict(uid, data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/customers/restrict/" + uid,
    method: "put",
    data: data
  });
}

export function deleteRestrict(uid){
  return request({
    url: "/api/customers/restrict/" + uid,
    method: "delete",
    data: {idempotency: uuid.v1()}
  });
}

export function getRiskFeeOption(uid){
  return request({
    url: "/api/customers/riskfeeoption/" + uid,
    method: "get"
  });
}

export function updateRiskFeeOption(uid, data){
  //data.idempotency = uuid.v1()
  return request({
    url: "/api/customers/riskfeeoption/" + uid,
    method: "put",
    data: data
  });
}

export function checkContractAvailability(uid){
  //data.idempotency = uuid.v1()
  return request({
    url: "/api/customers/contract/check/" + uid,
    method: "get"
  });
}

export function getContractBalance(uid){
  //data.idempotency = uuid.v1()
  return request({
    url: "/api/customers/contract/balance/" + uid,
    method: "get"
  });
}

export function getContractState(uid, type){
  //data.idempotency = uuid.v1()
  return request({
    url: `/api/customers/contract/state/${type}/${uid}`,
    method: "get"
  });
}
export function getContractStateHistory(uid, type){
  //data.idempotency = uuid.v1()
  return request({
    url: `/api/customers/contract/state/${type}/${uid}/history`,
    method: "get"
  });
}

export function createContract(data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/customers/contract/create",
    method: "post",
    data: data
  });
}
export function renewContract(data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/customers/contract/renew",
    method: "put",
    data: data
  });
}

export function getMonthlyFeeLog(bankholder_id, year){
  return request({
    url: `/api/customers/monthlyfeelog/${bankholder_id}`,
    method: "post",
    data: { year }
  });
}

export function exportMonthlyFeeLog(bankholder_id, year, filename){
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  const accessToken = encodeURIComponent(getToken())
  link.href = `${baseURL}/api/customers/monthlyfeelog/${bankholder_id}/${year}/export?access_token=${accessToken}`;
  if(filename){
    link.download = filename
  }
  link.click()
}